export const currentBranch = () => window.localStorage.getItem('branch')

export const currentRole = () => window.localStorage.getItem('user_role')

export const currentCurrency = () => {
  let branch = window.localStorage.getItem('branch')
  switch (branch) {
    case 'ID':
      return 'IDR'
    case 'PH':
      return 'PHP'
    default:
      return null
  }
}



// WEBPACK FOOTER //
// ./src/Utils/PrivilegeUtils.js